import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/**
 * Assign referral codes to all users without a code
 */
export const assignReferralCodes = async () => {
  try {
    const response = await api.post("/admin/assign-referral-codes");
    return {
      status: response.status,
      message: response.data || "Referral codes assigned successfully",
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || err.message || "Failed to assign referral codes",
    };
  }
};

/**
 * Reset referral code for a specific user
 */
export const resetReferralCode = async (userId) => {
  try {
    const response = await api.post(`/admin/reset-referral-code/${userId}`);
    return {
      status: response.status,
      message: response.data || "Referral code reset successfully",
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || err.message || "Failed to reset referral code",
    };
  }
};
